/* eslint-disable lingui/no-unlocalized-strings -- Native DEXPI class and relationship identifiers. */
import type { GraphNode } from './graphTypes'

export function isPipeOffPageConnector(node: GraphNode): boolean {
  return (
    node.dexpi.dexpi_class === 'Plant.Piping.FlowInPipeOffPageConnector' ||
    node.dexpi.dexpi_class === 'Plant.Piping.FlowOutPipeOffPageConnector'
  )
}

export function resolveOffPageConnectorReference(
  node: GraphNode
): GraphNode | undefined {
  if (!isPipeOffPageConnector(node)) return undefined
  const reference = node.getUniqueTargetNode('ConnectorReference')
  return reference?.dexpi.dexpi_class ===
    'Plant.Piping.PipeOffPageConnectorObjectReference' ||
    reference?.dexpi.dexpi_class ===
      'Plant.Piping.PipeOffPageConnectorReferenceByNumber'
    ? reference
    : undefined
}

export function resolvePeerOffPageConnector(
  node: GraphNode
): GraphNode | undefined {
  const reference = resolveOffPageConnectorReference(node)
  if (
    reference?.dexpi.dexpi_class !==
    'Plant.Piping.PipeOffPageConnectorObjectReference'
  )
    return undefined
  const target = reference.getUniqueTargetNode('ReferencedConnector')
  return target && target.id !== node.id && isPipeOffPageConnector(target)
    ? target
    : undefined
}
